import { Skeleton } from '@shared/components/shadcn';
import type { LotteryName } from '../../../../lottery-purchases/types';
import { LotteryHeaderContainer } from '../../../../LotteryHeaderContainer/LotteryHeaderContainer';

function Loading({ className, lotteryName }: { className: string; lotteryName: LotteryName }) {
  return (
    <LotteryHeaderContainer lotteryName={lotteryName} className={className}>
      <div className="flex flex-col gap-y-5">
        <div className="flex flex-col gap-y-2">
          <Skeleton className="h-7 w-1/1 bg-foreground/10" />
          <Skeleton className="h-9 w-4/5 bg-foreground/10" />
        </div>
        <div className="flex items-center gap-x-4">
          <Skeleton className="h-10 w-28 rounded-full bg-foreground/10" />
          <div className="flex flex-col gap-y-1">
            <Skeleton className="h-4 w-16 bg-foreground/10" />
            <Skeleton className="h-6 w-20 bg-foreground/10" />
          </div>
        </div>
      </div>
    </LotteryHeaderContainer>
  );
}

export { Loading };
